import React from 'react';

import { useSelector } from 'react-redux';
import { navigateTop } from "../routing/router-utils";
import { trackEvent } from '../analytics/tracking';
import { newCustomerEndpoint } from '../../constants/api-endpoints';
import DisplayError from '../common/DisplayError';
import Spinner from '../common/Spinner';

const ProcessRegistration = () => {

  const [registrationComplete, setRegistrationComplete] = React.useState();
  const [registrationError, setRegistrationError] = React.useState();
  const [showRegistrationError, setShowRegistrationError ] = React.useState();
  
  const name = useSelector(state => state.name);
  const email = useSelector(state => state.email);
  const password = useSelector(state => state.password);
  const street_address = useSelector(state => state.street_address);
  const city = useSelector(state => state.city);
  const state = useSelector(state => state.state);
  const zip_code = useSelector(state => state.zip_code);
  const apartment_number = useSelector(state => state.apartment_number);
  const dob = useSelector(state => state.dob);
  const tel_number = useSelector(state => state.tel_number);
  const marketing_accepted = useSelector(state => state.marketing_accepted);
  
  // Collect all the info required for registration
  const buildCustomerInfo = React.useCallback(() => {
    const info = {
      name,
      email,
      password,
      location: {
        street_address,
        city,
        state,
        zip_code,
        apartment_number
      },  
      dob, 
      tel_number,
      marketing_email_opted_in: marketing_accepted,
      marketing_sms_text_opted_in: marketing_accepted
    };
  
    // Reg will fail if apartment_number is empty string
    if (info.location['apartment_number'] === undefined ||
        /\S+/.test(info.location['apartment_number']) === false) {   
      delete info.location['apartment_number'];
    }
    return info;
  }, [name, email, password, street_address, city, state, zip_code, apartment_number, dob, tel_number, marketing_accepted]);
  
  React.useEffect(() => {
    try {
      if (!registrationError) {
        fetch( newCustomerEndpoint, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(buildCustomerInfo())
        }).then(response => response.json())
          .then(data => {
            // for logging
            const zipCode = zip_code || 'N/A';
            // check for errors
            if (data["error"]) {
              trackEvent('registration_failure', 'registration', `zip_${zipCode}_err_${data['error']}`);
              setRegistrationError(data["error"]);
              setShowRegistrationError(true);
            } else {
              trackEvent('registration_success', 'registration', `zip_${zipCode}`);
              setRegistrationComplete(true);
              navigateTop('/signUp/registrationComplete');
            }
          })
          .catch(error => {
            setRegistrationError(error);
          });
        } 
    } catch (e) {
      setRegistrationError(`registration failed ${e.message}`);
    }
  }, [buildCustomerInfo, zip_code, registrationError]);

  return (
    <>
      { !registrationComplete &&
        <Spinner color="white" inSmallLayout />
      }
  
      { registrationError &&
        <div>Error: {registrationError}</div>
      }
      
      { showRegistrationError &&
        <DisplayError 
          errorContext="registration"
          errorText={registrationError}
          errorId={email} 
          closeFn={() => setShowRegistrationError(false)} />
      }
    </>
  );
};

export default ProcessRegistration;